import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['x-access-token'] = process.env.REACT_APP_API_KEY;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const login = async (email, password) => {
  const response = await axiosInstance.post(`${baseUrl}/auth/login`, {
    email,
    password,
  });
  return response.data;
};

export const resetPassword = async email => {
  const response = await axiosInstance.get(`${baseUrl}/auth/reset-password`, {
    params: {
      email,
    },
  });
  return response.data;
};

export const validateToken = async token => {
  const response = await axiosInstance.get(`${baseUrl}/auth/validate-token`, {
    params: {
      token,
    },
  });
  return response.data;
};
